'use client';
var classes = {"root":"m_d57069b5","content":"m_b1336c6","viewport":"m_c0783ff9","viewportInner":"m_f8f631dd","scrollbar":"m_c44ba933","thumb":"m_d8b5e363","corner":"m_21657268"};

export { classes as default };
//# sourceMappingURL=ScrollArea.module.css.mjs.map
